BusinessClassSelectOrgView = undefined
queueRequire -> BusinessClassSelectOrgView = require 'views/organization/business-class-select-org-view'
ErrorView = undefined
queueRequire -> ErrorView = require 'views/error/error-view'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
SearchInputView = undefined
queueRequire -> SearchInputView = require 'views/search/search-input-view'
SearchState = undefined
queueRequire -> SearchState = require 'view-models/search-state'
$ = require 'jquery'
Auth = require 'db/auth'
l = require 'lib/localize'
log = require 'debug/log'
_ = require 'underscore'
Promise = require 'bluebird'
Util = require 'lib/util'
templates = require 'views/internal/templates'

module.exports =
  routes: [
    ['shortcuts', 'shortcutsView']
    ['shortcuts/overlay', 'shortcutsViewOverlay']
    ['blank', 'blankView']
    ['select-org-to-upgrade', 'businessClassSelectOrgView']
    ['select-team-to-upgrade', 'businessClassSelectTeamView']
    ['search(?*query)', 'searchView']
    ['power-ups', 'powerUpsView']
  ]

  businessClassSelectOrgView: ->
    @navigate '/select-team-to-upgrade', replace: true, trigger: true
    return

  businessClassSelectTeamView: ->
    pathname = '/select-team-to-upgrade'

    if !Auth.isLoggedIn()
      window.location = "/login?returnUrl=#{ pathname }"
      return

    Promise.using @getSpinner(), =>
      ModelLoader.for('top-level', 'loadMyOrganizations').then (member) =>
        @setViewType('select-org')

        notPremiumOrgs = _.filter(member.organizationList.models, (org) -> !org.isPremium())
        if notPremiumOrgs.length == 1
          @navigate "/#{ notPremiumOrgs[0].get('name') }/billing", { trigger: true }
          return

        @setLocation
          title: l('select organization to upgrade to business class')
          location: pathname

        @clearPreviousView()
        view = @topLevelView(BusinessClassSelectOrgView, member)

        @showHeader()
        $('#content').html view.render().el
    .done()

  searchView: ->
    log('controller', ['searchView'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        if !Auth.isLoggedIn()
          @displayErrorPage()
          return

        @setViewType('search')
        @clearPreviousView()
        me = Auth.me()
        headerCache = ModelCache

        query = Util.getQueryParameter('q', "")
        inputView = @topLevelView(SearchInputView, me, modelCache: headerCache)
        resultsView = inputView.getResultsView()

        SearchState.setQuery(query)
        resultsView.update()
        @showHeader({ noSearch: true })

        $('#classic-body').addClass('body-search-page')

        $('#content')
        .append(inputView.render().el)
        .append(resultsView.render().el)

        _.defer -> inputView.focusInput()
        return
    .done()

  blankView: ->
    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('blank')
        @clearPreviousView()
        @showHeader()
        return
    .done()

  shortcutsViewOverlay: ->
    ModelLoader.waitFor 'headerData', =>
      title = l('keyboard shortcuts')
      location = 'shortcuts/overlay'

      if @onAnyBoardView()
        @saveBoardsView()
        Dialog.show
          html: templates.fill('shortcuts')
          maxWidth: 550
          hide: (isNavigating) =>
            if !isNavigating
              @loadBoardsView()
        @setLocation(title, location)
      else
        @navigate '/shortcuts', replace: true, trigger: true

    return

  shortcutsView: ->
    ModelLoader.waitFor 'headerData', =>
      title = l('keyboard shortcuts')
      location = 'shortcuts'

      if @onAnyBoardView()
        @navigate '/shortcuts/overlay', replace: true, trigger: true
      else
        @staticView {
          title
          location
          bodyClass: 'body-single-column'
          template: -> templates.fill('shortcuts')
        }

    return

  errorView: ({ title, location, data }) ->
    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('error')
        @clearPreviousView()
        @showHeader()

        fullName = if Auth.me()?.attributes
          Auth.me().attributes.fullName
        else
          ''

        _.extend data, { fullName: fullName }

        errorView = @topLevelView(ErrorView, data)
        $('#content').append(errorView.render().el)
        @focusContent()

        @setLocation({ title, location })
    .done()

  staticView: ({ title, location, template, templateData, bodyClass, viewType, headerOpts }) ->

    log('controller', [location + 'View'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType(viewType ? location)
        @clearPreviousView()
        @showHeader(headerOpts)

        template(templateData)
      .then (html) =>
        $('#classic-body').addClass(bodyClass)
        $('#content').html(html)
        @focusContent()

        @setLocation({ title, location })
    .done()

  powerUpsView: ->
    @navigate '/power-ups', replace: true, trigger: true
    return



// WEBPACK FOOTER //
// ./app/scripts/controller/other-routes.coffee